export default "/images/vendor/flag-icons/flags/4x3/vg.svg?c96c4a54f0843aadb960e566142494fd";